import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';

export interface PushSubscriptionHealthRow {
  userid: string;
  endpoint: string;
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
  failure_count: number;
  last_error: string | null;
  last_error_at: string | null;
  health_status: string;
  hours_since_last_use: number | null;
}

export const PushSubscriptionHealth: Entity<PushSubscriptionHealthRow> = {
  id: 'PushSubscriptionHealth',
  title: 'Push Subscription Health',
  service: 'main',
  rowLabel: (row: PushSubscriptionHealthRow) => `${row.health_status} - ${row.endpoint.substring(0, 50)}`,
  primaryKeyFields: ['endpoint'],
  source: {
    tableName: 'public.push_subscription_health',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [
    ['health_status', 'ASC'],
    ['failure_count', 'DESC'],
  ],
  defaultFilters: [],
  fields: {
    userid: {
      seq: 5,
      type: FieldType.Reference,
      label: 'User',
      refEntity: UserView,
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    health_status: {
      seq: 10,
      type: FieldType.Options,
      label: 'Health Status',
      listColumn: true,
      options: [
        { id: 'healthy', label: 'Healthy' },
        { id: 'degraded', label: 'Degraded' },
        { id: 'unhealthy', label: 'Unhealthy' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    failure_count: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Failure Count',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    last_used_at: {
      seq: 20,
      type: FieldType.Datetime,
      label: 'Last Used',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    hours_since_last_use: {
      seq: 25,
      type: FieldType.Decimal,
      label: 'Hours Since Last Use',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    endpoint: {
      seq: 30,
      type: FieldType.Text,
      label: 'Endpoint',
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
    },
    last_error: {
      seq: 35,
      type: FieldType.Text,
      label: 'Last Error',
      persistence: PersistenceType.BackEndManaged,
      formColumnWidths: { xs: 12 },
    },
    last_error_at: {
      seq: 40,
      type: FieldType.Datetime,
      label: 'Last Error At',
      persistence: PersistenceType.BackEndManaged,
    },
    created_at: {
      seq: 45,
      type: FieldType.Datetime,
      label: 'Created At',
      persistence: PersistenceType.BackEndManaged,
    },
    updated_at: {
      seq: 50,
      type: FieldType.Datetime,
      label: 'Updated At',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
